module.exports = __webpack_public_path__ + "assets/img/more-btn-b4d2ca9d.png";